import React from 'react'

const STYLES = {
  verified: 'bg-red-100 text-red-700',
  pending: 'bg-amber-100 text-amber-800'
}

// Read-only marker for circumvention found in a meeting's transcript. The API
// leaves out false alarms, so anything here is pending review in the admin
// portal or verified there.
function CircumventionPill({ incidents, className = '' }) {
  if (!incidents || incidents.length === 0) {
    return null
  }

  const verified = incidents.some((incident) => incident.outcome === 'verified')
  const label = verified ? 'Circumvention verified' : 'Circumvention pending'
  const title = verified
    ? 'Staff confirmed an attempt to go around Teach Me 2'
    : 'Possible attempt to go around Teach Me 2, waiting for review'

  return (
    <span title={title} className={`inline-block rounded-full px-2 py-0.5 text-[11px] font-medium ${verified ? STYLES.verified : STYLES.pending} ${className}`}>
      {label}
    </span>
  )
}

export default CircumventionPill
